// config custom par env

export const ENV = 'mgHabitat';
